export function safetyParse<T>(value: string): { value: T | string; hasError?: boolean } {
  try {
    const parsedValue = JSON.parse(value);

    return { value: parsedValue };
  } catch {
    return { value, hasError: true };
  }
}
